import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import confetti from 'canvas-confetti';
import './ResultPage.css';
import Navbar from "./Navbar/Navbar";


const ResultPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const message = location.state?.message || 'You will get the report on mail after 24-48 business hours.';

    useEffect(() => {
        // Auto-fire confetti on component mount
        const duration = 3000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

        const randomInRange = (min, max) => Math.random() * (max - min) + min;

        const interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
            });
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
            });
        }, 250);

        return () => clearInterval(interval);
    }, []);

    const handleOkClick = () => {
        navigate('/');
    };
    useEffect(() => {
        if (!location.state?.fromQuiz && !location.state?.fromQuizSelection) {
            navigate('/');
        }
    }, [location, navigate]);

    return (
        <div className="result-page">
            <Navbar/>
            <div className="result-content-wrapper">
                <h2 className="congratulations-text">🎉 Congratulations! 🎉</h2>
                <div className="result-card">
                    <div className="celebration-container">
                        <div className="confetti-overlay" />
                        <h2 className="assignment-completed">Assessment Completed</h2>
                        <p className="success-message">{message}</p>
                        <button
                            onClick={handleOkClick}
                            className="ok-button"
                        >
                            Return to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultPage;